import { computed } from 'vue';
import { useUsersStore } from '@/stores';
import { storeToRefs } from 'pinia';

interface RoleCheckOptions {
  rolesAllowed?: number[];
  requiresSuperadmin?: boolean;
}

export function useRoleCheck(options: RoleCheckOptions) {
  const { currentUser } = storeToRefs(useUsersStore());

  const isUserAuthorized = computed(() => {
    if (options.requiresSuperadmin) {
      return currentUser.value?.isSuperadmin ?? false;
    }
    const role = currentUser.value?.role;
    return role !== undefined && (options.rolesAllowed ?? []).includes(role);
  });

  return { isUserAuthorized };
}
